{{#if siteLink}}
<h3 class="user-card-public-field">
  <span class="user-field-name">{{siteLink.name}}</span>:
  <span class="user-field-value">{{{siteLink.link}}}</span>
</h3>
{{/if}}